<template>
    <Monthlive/>
</template>

<script>
import { Monthlive } from 'shared'

export default {
    name: 'monthlive',
    components: {
        Monthlive
    },
    data() {
        return {
            params: {
                main: 3,
                sub: 0,
            }
        }
    },
    created() {
        this.$store.commit('getMonth', this.params)
    },
}
</script>